<template>
  <div
    id="visit-guide-map-exhibitions"
    class="
      @600/layout/grid:column:span:1
      @600/layout/height:100%
      @600/layout/order:1
      layout/order:2
      layout/padding:top:page:2
      layout/width:100%
    "
    style="
      overflow-y: auto;
    ">
    <div
      class="
        $typography/size:medium-large
        layout/grid
        layout/width:100%
      ">
      <h2
        class="
          layout/padding:left:page
          typography
        ">On this floor
      </h2>
      <h3 v-if="this.currentExhibitions?.length > 0"
        class="
          $color/gray:767
          $typography/size:medium
          color
          layout/margin:bottom:page
          layout/margin:top:page:2
          layout/padding:left:page
          typography
        ">
        Exhibitions
      </h3>
      <ul v-if="this.currentExhibitions?.length > 0"
        class="
          @600/layout/flex:column
          @600/layout/grid:gap:page
          layout/flex:row
          layout/grid:gap:cap
          layout/padding:bottom:cap
          layout/padding:left:page
          layout/padding:right:page
          layout/width:100%
          scrolling-container
        "
        style="
          overflow-x: auto;
        ">
        <visitGuideExhibitionCard
          v-for="exhibition in this.currentExhibitions"
          :exhibition="exhibition"
          :setHighlightedElement="setHighlightedElement"
          :key="exhibition.Id"
          :showDrawer="showDrawer"
        />
      </ul>
      <div v-else-if="!this.currentThemeGroup"
        class="$typography/scale:down">
        <p
          class="
            $color/gray:767
            layout/margin:top:page
            layout/padding:left:page
            typography
          ">No current exhibitions on view</p>
      </div>
    </div>
    <themeGroupRow
      v-if="this.currentThemeGroup"
      :themeGroup="this.currentThemeGroup"
      :setHighlightedElement="setHighlightedElement"
      :showDrawer="showDrawer"
    />
    <section v-if="this.currentAmenities.length > 0" class="layout/padding:bottom:page:2">
      <h3
        class="
          $color/gray:767
          $typography/size:medium
          color
          layout/margin:bottom:page
          layout/margin:top:page:2
          layout/padding:left:page
          typography
        ">
        Amenities
      </h3>
      <ul
        class="
          layout/flex:column
          layout/grid:gap:row:page
          layout/padding:left:page
        ">
        <li v-for="amenity in this.currentAmenities"
          class="
            layout/align:center
            layout/flex
            layout/grid:gap:cap
          ">
          <floorAmenity
            class="layout/width"
            :amenityName="amenity.Data.amenity_icon"
            style="
              list-style-type: none;
              --layout--width: 24px;
            "
          />
          <p
            class="
              $typography/size:medium
              typography
            "
            v-html="amenity.Title">

          </p>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
  import visitGuideExhibitionCard from './visit-guide-map-exhibition-card.vue';
  import themeGroupRow from './visit-guide-map-theme-group.vue';
  import floorAmenity from 'Components/screens/directory/floor-amenity.vue';

  export default {
    props: {
      currentFloor: String,
      floors: Object,
      setHighlightedElement: {
        type: Function,
        required: true
      },
      showDrawer: {
        type: Function,
        required: true
      }
    },
    components: {
      visitGuideExhibitionCard,
      themeGroupRow,
      floorAmenity
    },
    computed: {
      currentFloorData() {
        return this.floors[this.currentFloor];
      },
      currentExhibitions() {
        return this.floors[this.currentFloor]?.exhibitions ?? [];
      },
      currentThemeGroup() {
        return this.floors[this.currentFloor]?.themeGroup;
      },
      currentAmenities() {
        return this.floors[this.currentFloor]?.amenities ?? [];
      }
    }
  } 
</script>
